import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PickFolderDialog } from 'app/domains/common-ui/pickers';
export function Location(props) {
    const { folder, disabled, onSelectFolder } = props;
    const [renderDialog, setRenderDialog] = useState(false);
    const showDialog = () => setRenderDialog(true);
    const hideDialog = () => setRenderDialog(false);
    const handleSubmit = (newFolder) => {
        onSelectFolder(newFolder);
        hideDialog();
    };
    const locationLabel = t({
        message: 'Location',
        comment: 'Upload documents dialog settings - Location label',
    });
    const folderName = folder === null || folder === void 0 ? void 0 : folder.name;
    const initialFolderId = folder === null || folder === void 0 ? void 0 : folder.id;
    return (<Fragment>
      {renderDialog && (<PickFolderDialog dialogTitle={t({
                comment: 'Select location dialog - Choose folder title',
                message: 'Select location',
            })} dialogSubtitle={t({
                comment: 'Choose location dialog - Choose folder description',
                message: 'Choose where you want to save your documents',
            })} submitLabel={t({
                comment: 'Choose location dialog - Save here button',
                message: 'Save here',
            })} initialFolderId={initialFolderId} onSubmit={handleSubmit} onClose={hideDialog}/>)}

      <Box alignItems="center" justifyContent="space-between">
        {folderName ? (<AvatarWithLabel size="sm" appearance="light" title={folderName} subtitle={locationLabel}>
            <Falcon icon="folder"/>
          </AvatarWithLabel>) : (<AvatarWithLabel size="sm" appearance="light" title={locationLabel} subtitle={t({
                message: 'Select where to store your documents',
                comment: 'Upload documents dialog settings - Location description',
            })}>
            <Falcon icon="folder"/>
          </AvatarWithLabel>)}
        <Button type="button" size="xs" appearance={folderName ? 'secondary' : 'primary'} disabled={disabled} onClick={showDialog}>
          {folderName ? (<Trans comment="Upload documents dialog settings - Change location button label">Change location</Trans>) : (<Trans comment="Upload documents dialog settings - Pick location button label">Pick location</Trans>)}
        </Button>
      </Box>
    </Fragment>);
}
